export default [
  {
    path: '/activity-20251030-main',
    component: () => import('./Page.vue'),
    meta: { expire: '2025-11-10T23:59:59.000+08:00', title: '万圣节', id: 4 },
  },
  {
    path: '/activity-20251030-rule',
    component: () => import('./Rule.vue'),
    meta: { expire: '2025-11-10T23:59:59.000+08:00', title: '万圣节-规则', id: 4 },
  },
]
